import React from "react";
import { IconProps } from "./IconProps";

const ArrowLineUpRightIcon: React.FC<IconProps> = ({
  size,
  thickness,
  ariaLabel,
  color = "currentColor",
}) => {
  switch (`${size}${thickness}`) {
    case "20Light":
      return (
        <svg
          aria-label={ariaLabel}
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill={color}
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M17.5 16.875C17.5 17.0408 17.4342 17.1997 17.3169 17.3169C17.1997 17.4342 17.0408 17.5 16.875 17.5H3.125C2.95924 17.5 2.80027 17.4342 2.68306 17.3169C2.56585 17.1997 2.5 17.0408 2.5 16.875C2.5 16.7092 2.56585 16.5503 2.68306 16.4331C2.80027 16.3158 2.95924 16.25 3.125 16.25H16.875C17.0408 16.25 17.1997 16.3158 17.3169 16.4331C17.4342 16.5503 17.5 16.7092 17.5 16.875ZM6.25 13.75C6.3321 13.7501 6.41341 13.734 6.48928 13.7026C6.56515 13.6712 6.6341 13.6252 6.69219 13.5672L14.375 5.88359V11.875C14.375 12.0408 14.4408 12.1997 14.5581 12.3169C14.6753 12.4342 14.8342 12.5 15 12.5C15.1658 12.5 15.3247 12.4342 15.4419 12.3169C15.5592 12.1997 15.625 12.0408 15.625 11.875V4.375C15.625 4.20924 15.5592 4.05027 15.4419 3.93306C15.3247 3.81585 15.1658 3.75 15 3.75H7.5C7.33424 3.75 7.17527 3.81585 7.05806 3.93306C6.94085 4.05027 6.875 4.20924 6.875 4.375C6.875 4.54076 6.94085 4.69973 7.05806 4.81694C7.17527 4.93415 7.33424 5 7.5 5H13.4914L5.80781 12.6828C5.72031 12.7702 5.6607 12.8816 5.63654 13.0029C5.61239 13.1242 5.62477 13.25 5.67211 13.3642C5.71946 13.4785 5.79964 13.5762 5.90251 13.6448C6.00538 13.7135 6.12632 13.7501 6.25 13.75Z"
            fill={color}
          />
        </svg>
      );
    case "20Reg":
      return (
        <svg
          aria-label={ariaLabel}
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill={color}
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M16.5 16C16.5 16.1547 16.4385 16.3031 16.3291 16.4125C16.2197 16.5219 16.0714 16.5833 15.9167 16.5833H3.08333C2.92862 16.5833 2.78025 16.5219 2.67085 16.4125C2.56146 16.3031 2.5 16.1547 2.5 16C2.5 15.8453 2.56146 15.6969 2.67085 15.5875C2.78025 15.4781 2.92862 15.4167 3.08333 15.4167H15.9167C16.0714 15.4167 16.2197 15.4781 16.3291 15.5875C16.4385 15.6969 16.5 15.8453 16.5 16ZM6 13.0833C6.07663 13.0834 6.15251 13.0684 6.22333 13.0391C6.29414 13.0098 6.35849 12.9669 6.41271 12.9127L13.5833 5.74135V11.3333C13.5833 11.488 13.6448 11.6364 13.7542 11.7458C13.8636 11.8552 14.012 11.9167 14.1667 11.9167C14.3214 11.9167 14.4697 11.8552 14.5791 11.7458C14.6885 11.6364 14.75 11.488 14.75 11.3333V4.33333C14.75 4.17862 14.6885 4.03025 14.5791 3.92085C14.4697 3.81146 14.3214 3.75 14.1667 3.75H7.16667C7.01196 3.75 6.86358 3.81146 6.75419 3.92085C6.64479 4.03025 6.58333 4.17862 6.58333 4.33333C6.58333 4.48804 6.64479 4.63642 6.75419 4.74581C6.86358 4.85521 7.01196 4.91667 7.16667 4.91667H12.7586L5.58729 12.0873C5.50562 12.1689 5.44999 12.2729 5.42744 12.3861C5.4049 12.4993 5.41645 12.6166 5.46064 12.7233C5.50483 12.8299 5.57966 12.9211 5.67568 12.9852C5.77169 13.0493 5.88456 13.0834 6 13.0833Z"
            fill={color}
          />
        </svg>
      );
    case "20Thin":
      return (
        <svg
          aria-label={ariaLabel}
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill={color}
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M13.7929 4.875L5.89645 12.7714C5.70118 12.9667 5.70118 13.2833 5.89645 13.4786C6.09171 13.6738 6.40829 13.6738 6.60355 13.4786L14.5 5.58211V11.875C14.5 12.1511 14.7239 12.375 15 12.375C15.2761 12.375 15.5 12.1511 15.5 11.875V4.37549C15.5 4.37533 15.5 4.37516 15.5 4.375C15.5 4.367 15.4998 4.359 15.4994 4.35101C15.4967 4.29393 15.4842 4.23723 15.4621 4.18361C15.4377 4.12464 15.4015 4.06939 15.3536 4.02145C15.3056 3.97351 15.2504 3.93734 15.1914 3.91294C15.1324 3.88849 15.0678 3.875 15 3.875H14.9999H7.5C7.22386 3.875 7 4.09886 7 4.375C7 4.65114 7.22386 4.875 7.5 4.875H13.7929ZM2.625 16.875C2.625 16.5989 2.84886 16.375 3.125 16.375H16.875C17.1511 16.375 17.375 16.5989 17.375 16.875C17.375 17.1511 17.1511 17.375 16.875 17.375H3.125C2.84886 17.375 2.625 17.1511 2.625 16.875Z"
            fill={color}
          />
        </svg>
      );
    case "24Reg":
      return (
        <svg
          aria-label={ariaLabel}
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill={color}
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M21 20.25C21 20.4489 20.921 20.6397 20.7803 20.7803C20.6397 20.921 20.4489 21 20.25 21H3.75C3.55109 21 3.36032 20.921 3.21967 20.7803C3.07902 20.6397 3 20.4489 3 20.25C3 20.0511 3.07902 19.8603 3.21967 19.7197C3.36032 19.579 3.55109 19.5 3.75 19.5H20.25C20.4489 19.5 20.6397 19.579 20.7803 19.7197C20.921 19.8603 21 20.0511 21 20.25ZM7.5 16.5C7.59852 16.5001 7.69609 16.4807 7.78714 16.4431C7.87818 16.4055 7.96092 16.3503 8.03063 16.2806L17.25 7.06031V14.25C17.25 14.4489 17.329 14.6397 17.4697 14.7803C17.6103 14.921 17.8011 15 18 15C18.1989 15 18.3897 14.921 18.5303 14.7803C18.671 14.6397 18.75 14.4489 18.75 14.25V5.25C18.75 5.05109 18.671 4.86032 18.5303 4.71967C18.3897 4.57902 18.1989 4.5 18 4.5H9C8.80109 4.5 8.61032 4.57902 8.46967 4.71967C8.32902 4.86032 8.25 5.05109 8.25 5.25C8.25 5.44891 8.32902 5.63968 8.46967 5.78033C8.61032 5.92098 8.80109 6 9 6H16.1897L6.96937 15.2194C6.86437 15.3243 6.79284 15.458 6.76385 15.6035C6.73487 15.7491 6.74972 15.9 6.80653 16.0371C6.86335 16.1742 6.95957 16.2914 7.08301 16.3738C7.20646 16.4562 7.35158 16.5001 7.5 16.5Z"
            fill={color}
          />
        </svg>
      );
    case "32Light":
      return (
        <svg
          aria-label={ariaLabel}
          width="32"
          height="32"
          viewBox="0 0 32 32"
          fill={color}
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M27.75 27C27.75 27.1989 27.671 27.3897 27.5303 27.5303C27.3897 27.671 27.1989 27.75 27 27.75H5C4.80109 27.75 4.61032 27.671 4.46967 27.5303C4.32902 27.3897 4.25 27.1989 4.25 27C4.25 26.8011 4.32902 26.6103 4.46967 26.4697C4.61032 26.329 4.80109 26.25 5 26.25H27C27.1989 26.25 27.3897 26.329 27.5303 26.4697C27.671 26.6103 27.75 26.8011 27.75 27ZM10 21.75C10.1988 21.7498 10.3895 21.6707 10.53 21.53L23.25 8.81125V19C23.25 19.1989 23.329 19.3897 23.4697 19.5303C23.6103 19.671 23.8011 19.75 24 19.75C24.1989 19.75 24.3897 19.671 24.5303 19.5303C24.671 19.3897 24.75 19.1989 24.75 19V7C24.75 6.80109 24.671 6.61032 24.5303 6.46967C24.3897 6.32902 24.1989 6.25 24 6.25H12C11.8011 6.25 11.6103 6.32902 11.4697 6.46967C11.329 6.61032 11.25 6.80109 11.25 7C11.25 7.19891 11.329 7.38968 11.4697 7.53033C11.6103 7.67098 11.8011 7.75 12 7.75H22.1887L9.47 20.47C9.36524 20.5749 9.29392 20.7085 9.26503 20.8539C9.23615 20.9993 9.251 21.15 9.30771 21.2869C9.36442 21.4239 9.46045 21.541 9.58367 21.6234C9.70688 21.7058 9.85176 21.7499 10 21.75Z"
            fill={color}
          />
        </svg>
      );
    default:
      return null;
  }
};

export default ArrowLineUpRightIcon;
